import React from "react";
import LegalPageRenderer from "../components/LegalPageRenderer";

const RefundPolicy = () => (
  <LegalPageRenderer slug="refund-policy" testId="refund-policy-page" />
);

export default RefundPolicy;
